import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, ViewChild, NgModule, Injectable, inject, HostListener } from '@angular/core';
import * as i3$1 from '@spartacus/core';
import { useFeatureStyles, I18nModule, UrlModule, FeaturesConfigModule, provideDefaultConfig, GlobalMessageType, ConfigModule, AuthGuard } from '@spartacus/core';
import { Subscription, combineLatest, from, mergeMap, queueScheduler, merge } from 'rxjs';
import { tap, map, take, distinctUntilChanged, filter, switchMap, shareReplay, skip, every, observeOn, debounce } from 'rxjs/operators';
import * as i3 from '@spartacus/cart/base/root';
import { CartOutlets, CartType, PromotionLocation, DeleteCartSuccessEvent, OrderEntriesSource, ProductImportStatus, DeleteCartEvent, DeleteCartFailEvent } from '@spartacus/cart/base/root';
import * as i3$2 from '@spartacus/storefront';
import { ICON_TYPE, CardModule, MediaModule, IconModule, SpinnerModule, OutletModule, SiteContextComponentService, SiteContextType, ListNavigationModule, FormUtils, DIALOG_TYPE, FormErrorsModule, KeyboardFocusModule } from '@spartacus/storefront';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i5 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i2 from '@spartacus/cart/saved-cart/root';
import { SavedCartFormType, SavedCartOrderEntriesContextToken, NewSavedCartOrderEntriesContextToken } from '@spartacus/cart/saved-cart/root';
import * as i6 from '@spartacus/cart/base/components/add-to-cart';
import { AddToCartModule } from '@spartacus/cart/base/components/add-to-cart';
import * as i1 from '@spartacus/cart/base/core';
import * as i5$1 from '@angular/forms';
import { UntypedFormGroup, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const _c0 = ["element"];
const _c1 = () => ({
  cxRoute: "savedCarts"
});
function AddToSavedCartComponent_ng_container_0_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6, 0);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵlistener("click", function AddToSavedCartComponent_ng_container_0_button_7_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const cart_r2 = i0.ɵɵnextContext().ngIf;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.saveCart(cart_r2));
    });
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("disabled", i0.ɵɵpipeBind1(2, 3, ctx_r2.disableSaveCartForLater$));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 5, "addToSavedCart.saveCartForLater"));
  }
}
function AddToSavedCartComponent_ng_container_0_a_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 7, 0);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵlistener("click", function AddToSavedCartComponent_ng_container_0_a_8_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const cart_r2 = i0.ɵɵnextContext().ngIf;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.saveCart(cart_r2));
    });
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("disabled", i0.ɵɵpipeBind1(2, 3, ctx_r2.disableSaveCartForLater$));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 5, "addToSavedCart.saveCartForLater"));
  }
}
function AddToSavedCartComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2)(2, "a", 3);
    i0.ɵɵpipe(3, "cxUrl");
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, AddToSavedCartComponent_ng_container_0_button_7_Template, 6, 7, "button", 4)(8, AddToSavedCartComponent_ng_container_0_a_8_Template, 6, 7, "a", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(3, 4, i0.ɵɵpureFunction0(8, _c1)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 6, "addToSavedCart.savedCarts"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "a11yUseButtonsForBtnLinks");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yUseButtonsForBtnLinks");
  }
}
function SavedCartDetailsActionComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2)(2, "div", 3)(3, "button", 4, 0);
    i0.ɵɵlistener("click", function SavedCartDetailsActionComponent_ng_container_0_Template_button_click_3_listener() {
      const cart_r2 = i0.ɵɵrestoreView(_r1).ngIf;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.openDialog(cart_r2, ctx_r2.savedCartFormType.DELETE));
    });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 3)(8, "button", 5, 0);
    i0.ɵɵlistener("click", function SavedCartDetailsActionComponent_ng_container_0_Template_button_click_8_listener() {
      const cart_r2 = i0.ɵɵrestoreView(_r1).ngIf;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.openDialog(cart_r2, ctx_r2.savedCartFormType.RESTORE));
    });
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 2, "savedCartDetails.deleteSavedCart"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 4, "savedCartList.makeCartActive"), " ");
  }
}
const _c2 = (a0, a1, a2) => ({
  displayAddToCart: true,
  addToCartString: a0,
  optionalBtn: a1,
  cartType: a2
});
const _c3 = (a0, a1, a2, a3, a4) => ({
  cartId: a0,
  cartIsLoading: a1,
  items: a2,
  promotionLocation: a3,
  options: a4
});
function SavedCartDetailsItemsComponent_ng_container_0_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 7);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function SavedCartDetailsItemsComponent_ng_container_0_ng_container_1_ng_template_3_Template(rf, ctx) {}
function SavedCartDetailsItemsComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SavedCartDetailsItemsComponent_ng_container_0_ng_container_1_div_1_Template, 2, 3, "div", 4);
    i0.ɵɵelementStart(2, "div", 5);
    i0.ɵɵtemplate(3, SavedCartDetailsItemsComponent_ng_container_0_ng_container_1_ng_template_3_Template, 0, 0, "ng-template", 6);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const cart_r1 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    const addToCartBtn_r3 = i0.ɵɵreference(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxOutlet", ctx_r1.CartOutlets.CART_ITEM_LIST)("cxOutletContext", i0.ɵɵpureFunction5(11, _c3, cart_r1.code, !i0.ɵɵpipeBind1(4, 3, ctx_r1.cartLoaded$), cart_r1.entries, ctx_r1.CartLocation.SavedCart, i0.ɵɵpureFunction3(7, _c2, i0.ɵɵpipeBind1(5, 5, ctx_r1.buyItAgainTranslation$), addToCartBtn_r3, ctx_r1.CartType.SELECTIVE)));
  }
}
function SavedCartDetailsItemsComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SavedCartDetailsItemsComponent_ng_container_0_ng_container_1_Template, 6, 17, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const cart_r1 = ctx.ngIf;
    i0.ɵɵnextContext();
    const emptyCartItems_r4 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (cart_r1 == null ? null : cart_r1.entries == null ? null : cart_r1.entries.length) > 0)("ngIfElse", emptyCartItems_r4);
  }
}
function SavedCartDetailsItemsComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
function SavedCartDetailsItemsComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-add-to-cart", 9);
  }
  if (rf & 2) {
    const ctx_ir5 = ctx.$implicit;
    i0.ɵɵproperty("productCode", ctx_ir5.item.product == null ? null : ctx_ir5.item.product.code)("product", ctx_ir5.item.product)("showQuantity", false)("options", ctx_ir5.options)("pickupStore", ctx_ir5.item.deliveryPointOfService == null ? null : ctx_ir5.item.deliveryPointOfService.name);
  }
}
function SavedCartDetailsOverviewComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2)(2, "div", 3)(3, "div", 4)(4, "div", 5);
    i0.ɵɵelement(5, "cx-card", 6);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementStart(7, "button", 7, 0);
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵlistener("click", function SavedCartDetailsOverviewComponent_ng_container_0_Template_button_click_7_listener() {
      const cart_r2 = i0.ɵɵrestoreView(_r1).ngIf;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.openDialog(cart_r2));
    });
    i0.ɵɵelement(11, "cx-icon", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 9);
    i0.ɵɵelement(13, "cx-card", 10);
    i0.ɵɵpipe(14, "async");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "div", 4);
    i0.ɵɵelement(16, "cx-card", 6);
    i0.ɵɵpipe(17, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 4);
    i0.ɵɵelement(19, "cx-card", 6);
    i0.ɵɵpipe(20, "cxDate");
    i0.ɵɵpipe(21, "async");
    i0.ɵɵelement(22, "cx-card", 6);
    i0.ɵɵpipe(23, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div", 4);
    i0.ɵɵelement(25, "cx-card", 6);
    i0.ɵɵpipe(26, "async");
    i0.ɵɵelement(27, "cx-card", 6);
    i0.ɵɵpipe(28, "async");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const cart_r2 = ctx.ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(6, 12, ctx_r2.getCartName(cart_r2 == null ? null : cart_r2.name)));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(9, 14, "savedCartDetails.editSavedCart"))("title", i0.ɵɵpipeBind1(10, 16, "savedCartDetails.editSavedCart"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("type", ctx_r2.iconTypes.PENCIL);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(14, 18, ctx_r2.getCartDescription(cart_r2 == null ? null : cart_r2.description)))("truncateText", true)("charactersLimit", 30);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(17, 20, ctx_r2.getCartId(cart_r2 == null ? null : cart_r2.code)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(21, 24, ctx_r2.getDateSaved(i0.ɵɵpipeBind1(20, 22, cart_r2 == null ? null : cart_r2.saveTime))));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(23, 26, ctx_r2.getCartItems(cart_r2 == null ? null : cart_r2.totalItems)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(26, 28, ctx_r2.getCartQuantity(cart_r2 == null ? null : cart_r2.totalUnitCount)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(28, 30, ctx_r2.getCartTotal(cart_r2 == null ? null : cart_r2.totalPriceWithTax == null ? null : cart_r2.totalPriceWithTax.formattedValue)));
  }
}
const _c4 = a0 => ({
  count: a0
});
const _c5 = a0 => ({
  savedCartId: a0
});
const _c6 = a0 => ({
  cxRoute: "savedCartsDetails",
  params: a0
});
function SavedCartListComponent_ng_container_0_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 7);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function SavedCartListComponent_ng_container_0_ng_container_1_ng_container_6_thead_2_th_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 16);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "savedCartList.quantityFull"), " ");
  }
}
function SavedCartListComponent_ng_container_0_ng_container_1_ng_container_6_thead_2_th_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 16);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "savedCartList.quantity"), " ");
  }
}
function SavedCartListComponent_ng_container_0_ng_container_1_ng_container_6_thead_2_thead_19_th_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 21);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "savedCartList.quantityFull"), " ");
  }
}
function SavedCartListComponent_ng_container_0_ng_container_1_ng_container_6_thead_2_thead_19_th_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 21);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "savedCartList.quantity"), " ");
  }
}
function SavedCartListComponent_ng_container_0_ng_container_1_ng_container_6_thead_2_thead_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "thead", 17)(1, "tr")(2, "th", 18);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th", 18);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th", 18);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, SavedCartListComponent_ng_container_0_ng_container_1_ng_container_6_thead_2_thead_19_th_11_Template, 3, 3, "th", 19)(12, SavedCartListComponent_ng_container_0_ng_container_1_ng_container_6_thead_2_thead_19_th_12_Template, 3, 3, "th", 19);
    i0.ɵɵelementStart(13, "th", 20);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "th", 18);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 7, "savedCartList.cartName"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 9, "savedCartList.cartId"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 11, "savedCartList.dateSaved"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "a11yQTY2Quantity");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yQTY2Quantity");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 13, "savedCartList.total"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 15, "savedCartList.actions"), " ");
  }
}
function SavedCartListComponent_ng_container_0_ng_container_1_ng_container_6_thead_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "thead", 11)(1, "thead", 11)(2, "th", 12);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th", 12);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th", 12);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, SavedCartListComponent_ng_container_0_ng_container_1_ng_container_6_thead_2_th_11_Template, 3, 3, "th", 13)(12, SavedCartListComponent_ng_container_0_ng_container_1_ng_container_6_thead_2_th_12_Template, 3, 3, "th", 13);
    i0.ɵɵelementStart(13, "th", 14);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "th", 12);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(19, SavedCartListComponent_ng_container_0_ng_container_1_ng_container_6_thead_2_thead_19_Template, 19, 17, "thead", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 8, "savedCartList.cartName"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 10, "savedCartList.cartId"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 12, "savedCartList.dateSaved"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "a11yQTY2Quantity");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yQTY2Quantity");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 14, "savedCartList.total"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 16, "savedCartList.actions"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "a11yTableHeaderReadout");
  }
}
function SavedCartListComponent_ng_container_0_ng_container_1_ng_container_6_tr_4_div_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "savedCartList.quantityFull"), " ");
  }
}
function SavedCartListComponent_ng_container_0_ng_container_1_ng_container_6_tr_4_div_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "savedCartList.quantity"), " ");
  }
}
function SavedCartListComponent_ng_container_0_ng_container_1_ng_container_6_tr_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 22);
    i0.ɵɵlistener("click", function SavedCartListComponent_ng_container_0_ng_container_1_ng_container_6_tr_4_Template_tr_click_0_listener() {
      const savedCart_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.goToSavedCartDetails(savedCart_r2));
    });
    i0.ɵɵelementStart(1, "td", 23)(2, "div", 24);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "a", 25);
    i0.ɵɵpipe(6, "cxUrl");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "td", 26)(9, "div", 24);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "a", 25);
    i0.ɵɵpipe(13, "cxUrl");
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "td", 27)(16, "div", 24);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "a", 25);
    i0.ɵɵpipe(20, "cxUrl");
    i0.ɵɵtext(21);
    i0.ɵɵpipe(22, "cxDate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(23, "td", 28);
    i0.ɵɵtemplate(24, SavedCartListComponent_ng_container_0_ng_container_1_ng_container_6_tr_4_div_24_Template, 3, 3, "div", 29)(25, SavedCartListComponent_ng_container_0_ng_container_1_ng_container_6_tr_4_div_25_Template, 3, 3, "div", 29);
    i0.ɵɵelementStart(26, "a", 25);
    i0.ɵɵpipe(27, "cxUrl");
    i0.ɵɵtext(28);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(29, "td", 30)(30, "div", 24);
    i0.ɵɵtext(31);
    i0.ɵɵpipe(32, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "a", 25);
    i0.ɵɵpipe(34, "cxUrl");
    i0.ɵɵtext(35);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(36, "td", 31)(37, "div", 24);
    i0.ɵɵtext(38);
    i0.ɵɵpipe(39, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "button", 32, 2);
    i0.ɵɵlistener("click", function SavedCartListComponent_ng_container_0_ng_container_1_ng_container_6_tr_4_Template_button_click_40_listener($event) {
      const savedCart_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.openDialog($event, savedCart_r2));
    });
    i0.ɵɵtext(42);
    i0.ɵɵpipe(43, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const savedCart_r2 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 18, "savedCartList.cartName"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(6, 20, i0.ɵɵpureFunction1(45, _c6, i0.ɵɵpureFunction1(43, _c5, savedCart_r2 == null ? null : savedCart_r2.code))));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", savedCart_r2 == null ? null : savedCart_r2.name, "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 22, "savedCartList.cartId"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(13, 24, i0.ɵɵpureFunction1(49, _c6, i0.ɵɵpureFunction1(47, _c5, savedCart_r2 == null ? null : savedCart_r2.code))));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(savedCart_r2 == null ? null : savedCart_r2.code);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 26, "savedCartList.dateSaved"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(20, 28, i0.ɵɵpureFunction1(53, _c6, i0.ɵɵpureFunction1(51, _c5, savedCart_r2 == null ? null : savedCart_r2.code))));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(22, 30, savedCart_r2 == null ? null : savedCart_r2.saveTime, "longDate"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxFeature", "a11yQTY2Quantity");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yQTY2Quantity");
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(27, 33, i0.ɵɵpureFunction1(57, _c6, i0.ɵɵpureFunction1(55, _c5, savedCart_r2 == null ? null : savedCart_r2.code))));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", savedCart_r2 == null ? null : savedCart_r2.totalUnitCount, "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(32, 35, "savedCartList.total"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(34, 37, i0.ɵɵpureFunction1(61, _c6, i0.ɵɵpureFunction1(59, _c5, savedCart_r2 == null ? null : savedCart_r2.code))));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", savedCart_r2 == null ? null : savedCart_r2.totalPrice == null ? null : savedCart_r2.totalPrice.formattedValue, "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(39, 39, "savedCartList.actions"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(43, 41, "savedCartList.makeCartActive"), " ");
  }
}
function SavedCartListComponent_ng_container_0_ng_container_1_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "table", 8);
    i0.ɵɵtemplate(2, SavedCartListComponent_ng_container_0_ng_container_1_ng_container_6_thead_2_Template, 20, 18, "thead", 9);
    i0.ɵɵelementStart(3, "tbody");
    i0.ɵɵtemplate(4, SavedCartListComponent_ng_container_0_ng_container_1_ng_container_6_tr_4_Template, 44, 63, "tr", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const savedCarts_r4 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "!a11yTableHeaderReadout");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", savedCarts_r4);
  }
}
function SavedCartListComponent_ng_container_0_ng_container_1_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33)(1, "div", 34)(2, "div");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 1, "savedCartList.notFound"));
  }
}
function SavedCartListComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SavedCartListComponent_ng_container_0_ng_container_1_div_1_Template, 2, 3, "div", 5);
    i0.ɵɵelementStart(2, "div", 6)(3, "h2");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, SavedCartListComponent_ng_container_0_ng_container_1_ng_container_6_Template, 5, 2, "ng-container", 4)(7, SavedCartListComponent_ng_container_0_ng_container_1_ng_template_7_Template, 5, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const noSavedCarts_r5 = i0.ɵɵreference(8);
    const savedCarts_r4 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(5, 4, "savedCartList.savedCarts", i0.ɵɵpureFunction1(7, _c4, savedCarts_r4.length)), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (savedCarts_r4 == null ? null : savedCarts_r4.length) > 0)("ngIfElse", noSavedCarts_r5);
  }
}
function SavedCartListComponent_ng_container_0_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
function SavedCartListComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SavedCartListComponent_ng_container_0_ng_container_1_Template, 9, 9, "ng-container", 4);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, SavedCartListComponent_ng_container_0_ng_template_3_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const loading_r6 = i0.ɵɵreference(4);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(2, 2, ctx_r2.isLoading$))("ngIfElse", loading_r6);
  }
}
const _c7 = a0 => ({
  name: a0
});
const _c8 = a0 => ({
  label: a0
});
function SavedCartFormDialogComponent_ng_container_0_h3_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "savedCartDialog.editSavedCart"), " ");
  }
}
function SavedCartFormDialogComponent_ng_container_0_h3_5_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "savedCartDialog.deleteSavedCart"), " ");
  }
}
function SavedCartFormDialogComponent_ng_container_0_h3_5_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "savedCartDialog.saveForLater"), " ");
  }
}
function SavedCartFormDialogComponent_ng_container_0_h3_5_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "savedCartDialog.restoreSavedCart"), " ");
  }
}
function SavedCartFormDialogComponent_ng_container_0_h3_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 13);
    i0.ɵɵtemplate(1, SavedCartFormDialogComponent_ng_container_0_h3_5_ng_container_1_Template, 3, 3, "ng-container", 14)(2, SavedCartFormDialogComponent_ng_container_0_h3_5_ng_container_2_Template, 3, 3, "ng-container", 14)(3, SavedCartFormDialogComponent_ng_container_0_h3_5_ng_container_3_Template, 3, 3, "ng-container", 14)(4, SavedCartFormDialogComponent_ng_container_0_h3_5_ng_container_4_Template, 3, 3, "ng-container", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.savedCartFormType.EDIT);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.savedCartFormType.DELETE);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.savedCartFormType.SAVE);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.savedCartFormType.RESTORE);
  }
}
function SavedCartFormDialogComponent_ng_container_0_div_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "savedCartDialog.editSavedCart"), " ");
  }
}
function SavedCartFormDialogComponent_ng_container_0_div_6_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "savedCartDialog.deleteSavedCart"), " ");
  }
}
function SavedCartFormDialogComponent_ng_container_0_div_6_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "savedCartDialog.saveForLater"), " ");
  }
}
function SavedCartFormDialogComponent_ng_container_0_div_6_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "savedCartDialog.restoreSavedCart"), " ");
  }
}
function SavedCartFormDialogComponent_ng_container_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, SavedCartFormDialogComponent_ng_container_0_div_6_ng_container_1_Template, 3, 3, "ng-container", 14)(2, SavedCartFormDialogComponent_ng_container_0_div_6_ng_container_2_Template, 3, 3, "ng-container", 14)(3, SavedCartFormDialogComponent_ng_container_0_div_6_ng_container_3_Template, 3, 3, "ng-container", 14)(4, SavedCartFormDialogComponent_ng_container_0_div_6_ng_container_4_Template, 3, 3, "ng-container", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.savedCartFormType.EDIT);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.savedCartFormType.DELETE);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.savedCartFormType.SAVE);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.savedCartFormType.RESTORE);
  }
}
function SavedCartFormDialogComponent_ng_container_0_ng_container_14_div_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "savedCartDialog.quantityFull"), " ");
  }
}
function SavedCartFormDialogComponent_ng_container_0_ng_container_14_div_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "savedCartDialog.quantity"), " ");
  }
}
function SavedCartFormDialogComponent_ng_container_0_ng_container_14_ng_container_34_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27)(1, "label")(2, "span", 28);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "input", 29);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_7_0;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 3, "savedCartDialog.nameOfCloneCart"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind2(6, 5, "savedCartDialog.defaultCloneCartName", i0.ɵɵpureFunction1(8, _c7, (tmp_7_0 = ctx_r1.form.get("name")) == null ? null : tmp_7_0.value)));
    i0.ɵɵproperty("maxLength", ctx_r1.nameMaxLength);
  }
}
function SavedCartFormDialogComponent_ng_container_0_ng_container_14_ng_container_34_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 23)(2, "input", 24);
    i0.ɵɵlistener("change", function SavedCartFormDialogComponent_ng_container_0_ng_container_14_ng_container_34_Template_input_change_2_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.toggleIsCloneSavedCart());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 25);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, SavedCartFormDialogComponent_ng_container_0_ng_container_14_ng_container_34_div_6_Template, 7, 10, "div", 26);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", ctx_r1.isCloneSavedCart);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 3, "savedCartDialog.keepCopySavedCart"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isCloneSavedCart);
  }
}
function SavedCartFormDialogComponent_ng_container_0_ng_container_14_ng_container_39_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 31);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("click", function SavedCartFormDialogComponent_ng_container_0_ng_container_14_ng_container_39_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.deleteCart(ctx_r1.cart.code));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", i0.ɵɵpipeBind1(1, 2, ctx_r1.isDisableDeleteButton$));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "savedCartDialog.delete"), " ");
  }
}
function SavedCartFormDialogComponent_ng_container_0_ng_container_14_ng_container_39_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SavedCartFormDialogComponent_ng_container_0_ng_container_14_ng_container_39_button_1_Template, 4, 6, "button", 30);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.cart.code);
  }
}
function SavedCartFormDialogComponent_ng_container_0_ng_container_14_ng_template_40_button_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 31);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("click", function SavedCartFormDialogComponent_ng_container_0_ng_container_14_ng_template_40_button_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.restoreSavedCart(ctx_r1.cart.code));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", i0.ɵɵpipeBind1(1, 2, ctx_r1.isDisableRestoreButton$));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "savedCartDialog.restore"), " ");
  }
}
function SavedCartFormDialogComponent_ng_container_0_ng_container_14_ng_template_40_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SavedCartFormDialogComponent_ng_container_0_ng_container_14_ng_template_40_button_0_Template, 4, 6, "button", 30);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", ctx_r1.cart.code);
  }
}
function SavedCartFormDialogComponent_ng_container_0_ng_container_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p", 15);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 16)(5, "div", 17)(6, "div", 18);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 19);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 17)(12, "div", 18);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 19);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "div", 17)(18, "div", 18);
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 19);
    i0.ɵɵtext(22);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(23, "div", 17);
    i0.ɵɵtemplate(24, SavedCartFormDialogComponent_ng_container_0_ng_container_14_div_24_Template, 3, 3, "div", 20)(25, SavedCartFormDialogComponent_ng_container_0_ng_container_14_div_25_Template, 3, 3, "div", 20);
    i0.ɵɵelementStart(26, "div", 19);
    i0.ɵɵtext(27);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(28, "div", 17)(29, "div", 18);
    i0.ɵɵtext(30);
    i0.ɵɵpipe(31, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "div", 19);
    i0.ɵɵtext(33);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(34, SavedCartFormDialogComponent_ng_container_0_ng_container_14_ng_container_34_Template, 7, 5, "ng-container", 2);
    i0.ɵɵelementStart(35, "div", 21)(36, "button", 22);
    i0.ɵɵlistener("click", function SavedCartFormDialogComponent_ng_container_0_ng_container_14_Template_button_click_36_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.close("Close Save Cart Dialog"));
    });
    i0.ɵɵtext(37);
    i0.ɵɵpipe(38, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(39, SavedCartFormDialogComponent_ng_container_0_ng_container_14_ng_container_39_Template, 2, 1, "ng-container", 12)(40, SavedCartFormDialogComponent_ng_container_0_ng_container_14_ng_template_40_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const isRestoreSavedCart_r7 = i0.ɵɵreference(41);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 16, ctx_r1.layoutOption === ctx_r1.savedCartFormType.DELETE ? "savedCartDialog.followingCartDelete" : "savedCartDialog.followingCartRestore"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 18, "savedCartDialog.name"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.cart == null ? null : ctx_r1.cart.name, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 20, "savedCartDialog.id"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.cart == null ? null : ctx_r1.cart.code, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(20, 22, "savedCartDialog.description"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.cart == null ? null : ctx_r1.cart.description, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "a11yQTY2Quantity");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yQTY2Quantity");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.cart == null ? null : ctx_r1.cart.totalUnitCount, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(31, 24, "savedCartDialog.total"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.cart == null ? null : ctx_r1.cart.totalPriceWithTax == null ? null : ctx_r1.cart.totalPriceWithTax.formattedValue, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.layoutOption === ctx_r1.savedCartFormType.RESTORE);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(38, 26, "savedCartDialog.cancel"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.layoutOption === ctx_r1.savedCartFormType.DELETE)("ngIfElse", isRestoreSavedCart_r7);
  }
}
function SavedCartFormDialogComponent_ng_container_0_ng_template_15_ng_container_0_p_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 44);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "formLegend.required"), " ");
  }
}
function SavedCartFormDialogComponent_ng_container_0_ng_template_15_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p", 15);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, SavedCartFormDialogComponent_ng_container_0_ng_template_15_ng_container_0_p_4_Template, 3, 3, "p", 43);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "savedCartDialog.itemsSavedForLater"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
  }
}
function SavedCartFormDialogComponent_ng_container_0_ng_template_15_abbr_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "abbr", 45);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2, "*");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, "common.required"));
  }
}
function SavedCartFormDialogComponent_ng_container_0_ng_template_15_cx_form_errors_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 46);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c8, i0.ɵɵpipeBind1(1, 2, "savedCartDialog.savedCartName")))("control", ctx_r1.form.get("name"));
  }
}
function SavedCartFormDialogComponent_ng_container_0_ng_template_15_cx_form_errors_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 47);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("control", ctx_r1.form.get("name"));
  }
}
function SavedCartFormDialogComponent_ng_container_0_ng_template_15_cx_form_errors_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 48);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c8, i0.ɵɵpipeBind1(1, 2, "savedCartDialog.savedCartDescription")))("control", ctx_r1.form.get("description"));
  }
}
function SavedCartFormDialogComponent_ng_container_0_ng_template_15_cx_form_errors_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 47);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("control", ctx_r1.form.get("description"));
  }
}
function SavedCartFormDialogComponent_ng_container_0_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, SavedCartFormDialogComponent_ng_container_0_ng_template_15_ng_container_0_Template, 5, 4, "ng-container", 2);
    i0.ɵɵelementStart(1, "div", 16);
    i0.ɵɵelementContainerStart(2);
    i0.ɵɵelementStart(3, "label")(4, "span", 32);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵtemplate(7, SavedCartFormDialogComponent_ng_container_0_ng_template_15_abbr_7_Template, 3, 3, "abbr", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "input", 34);
    i0.ɵɵtemplate(9, SavedCartFormDialogComponent_ng_container_0_ng_template_15_cx_form_errors_9_Template, 2, 6, "cx-form-errors", 35)(10, SavedCartFormDialogComponent_ng_container_0_ng_template_15_cx_form_errors_10_Template, 1, 1, "cx-form-errors", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 16)(12, "label")(13, "span", 32);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "cxTranslate");
    i0.ɵɵelementStart(16, "span", 37);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(19, "textarea", 38);
    i0.ɵɵtemplate(20, SavedCartFormDialogComponent_ng_container_0_ng_template_15_cx_form_errors_20_Template, 2, 6, "cx-form-errors", 39)(21, SavedCartFormDialogComponent_ng_container_0_ng_template_15_cx_form_errors_21_Template, 1, 1, "cx-form-errors", 36);
    i0.ɵɵelementStart(22, "p", 40);
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "cxTranslate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(25, "div", 21)(26, "button", 41);
    i0.ɵɵpipe(27, "async");
    i0.ɵɵlistener("click", function SavedCartFormDialogComponent_ng_container_0_ng_template_15_Template_button_click_26_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.close("Close Save Cart Dialog"));
    });
    i0.ɵɵtext(28);
    i0.ɵɵpipe(29, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "button", 42);
    i0.ɵɵpipe(31, "async");
    i0.ɵɵlistener("click", function SavedCartFormDialogComponent_ng_container_0_ng_template_15_Template_button_click_30_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.saveOrEditCart(ctx_r1.cart == null ? null : ctx_r1.cart.code));
    });
    i0.ɵɵtext(32);
    i0.ɵɵpipe(33, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r1.layoutOption === ctx_r1.savedCartFormType.SAVE);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(6, 18, "savedCartDialog.savedCartName"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
    i0.ɵɵadvance();
    i0.ɵɵproperty("maxLength", ctx_r1.nameMaxLength);
    i0.ɵɵattribute("aria-describedby", "nameError");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(15, 20, "savedCartDialog.savedCartDescription"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" (", i0.ɵɵpipeBind1(18, 22, "savedCartDialog.optional"), ") ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("maxLength", ctx_r1.descriptionMaxLength);
    i0.ɵɵattribute("aria-describedby", "descriptionError");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(24, 24, "savedCartDialog.charactersLeft", i0.ɵɵpureFunction1(35, _c4, ctx_r1.descriptionsCharacterLeft)), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", i0.ɵɵpipeBind1(27, 27, ctx_r1.isLoading$));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(29, 29, "savedCartDialog.cancel"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", i0.ɵɵpipeBind1(31, 31, ctx_r1.isLoading$));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(33, 33, "savedCartDialog.save"), " ");
  }
}
function SavedCartFormDialogComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵlistener("esc", function SavedCartFormDialogComponent_ng_container_0_Template_div_esc_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close("Escape clicked"));
    });
    i0.ɵɵelementStart(2, "form", 4)(3, "div", 5);
    i0.ɵɵelementContainerStart(4, 6);
    i0.ɵɵtemplate(5, SavedCartFormDialogComponent_ng_container_0_h3_5_Template, 5, 4, "h3", 7)(6, SavedCartFormDialogComponent_ng_container_0_div_6_Template, 5, 4, "div", 7);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementStart(7, "button", 8);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵpipe(9, "async");
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵlistener("click", function SavedCartFormDialogComponent_ng_container_0_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close("Close Save Cart Dialog"));
    });
    i0.ɵɵelementStart(11, "span", 9);
    i0.ɵɵelement(12, "cx-icon", 10);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(13, "div", 11);
    i0.ɵɵtemplate(14, SavedCartFormDialogComponent_ng_container_0_ng_container_14_Template, 42, 28, "ng-container", 12)(15, SavedCartFormDialogComponent_ng_container_0_ng_template_15_Template, 34, 37, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const saveAndEditCart_r9 = i0.ɵɵreference(16);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFocus", ctx_r1.focusConfig);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.form);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitch", ctx_r1.layoutOption);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yDialogsHeading");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yDialogsHeading");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(8, 11, "common.close"));
    i0.ɵɵproperty("disabled", i0.ɵɵpipeBind1(9, 13, ctx_r1.isLoading$));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(10, 15, "common.close"));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.CLOSE);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.layoutOption === ctx_r1.savedCartFormType.DELETE || ctx_r1.layoutOption === ctx_r1.savedCartFormType.RESTORE)("ngIfElse", saveAndEditCart_r9);
  }
}
class AddToSavedCartComponent {
  constructor(activeCartFacade, authService, routingService, vcr, launchDialogService) {
    this.activeCartFacade = activeCartFacade;
    this.authService = authService;
    this.routingService = routingService;
    this.vcr = vcr;
    this.launchDialogService = launchDialogService;
    this.subscription = new Subscription();
    this.loggedIn = false;
    useFeatureStyles('a11yExpandedFocusIndicator');
    useFeatureStyles('a11yUseButtonsForBtnLinks');
  }
  ngOnInit() {
    this.cart$ = combineLatest([this.activeCartFacade.getActive(), this.authService.isUserLoggedIn()]).pipe(tap(([_, loggedIn]) => this.loggedIn = loggedIn), map(([activeCart]) => activeCart));
    this.disableSaveCartForLater$ = this.cart$.pipe(map(cart => !cart.entries?.length));
  }
  saveCart(cart) {
    this.subscription.add(this.disableSaveCartForLater$.subscribe(isDisabled => {
      if (isDisabled) {
        return;
      }
      if (this.loggedIn) {
        this.openDialog(cart);
      } else {
        this.routingService.go({
          cxRoute: 'login'
        });
      }
    }));
  }
  openDialog(cart) {
    const dialog = this.launchDialogService.openDialog("SAVED_CART" /* LAUNCH_CALLER.SAVED_CART */, this.element, this.vcr, {
      cart,
      layoutOption: 'save'
    });
    if (dialog) {
      this.subscription.add(dialog.pipe(take(1)).subscribe());
    }
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  static {
    this.ɵfac = function AddToSavedCartComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddToSavedCartComponent)(i0.ɵɵdirectiveInject(i3.ActiveCartFacade), i0.ɵɵdirectiveInject(i3$1.AuthService), i0.ɵɵdirectiveInject(i3$1.RoutingService), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i3$2.LaunchDialogService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AddToSavedCartComponent,
      selectors: [["cx-add-to-saved-cart"]],
      viewQuery: function AddToSavedCartComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.element = _t.first);
        }
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["element", ""], [4, "ngIf"], [1, "cx-add-to-saved-cart-container"], ["cxAutoFocus", "", 1, "link", "cx-action-link", 3, "routerLink"], ["class", "link cx-action-link", "cxAutoFocus", "", 3, "disabled", "click", 4, "cxFeature"], ["tabindex", "0", "class", "link cx-action-link", "cxAutoFocus", "", 3, "disabled", "click", 4, "cxFeature"], ["cxAutoFocus", "", 1, "link", "cx-action-link", 3, "click"], ["tabindex", "0", "cxAutoFocus", "", 1, "link", "cx-action-link", 3, "click"]],
      template: function AddToSavedCartComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, AddToSavedCartComponent_ng_container_0_Template, 9, 9, "ng-container", 1);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.cart$));
        }
      },
      dependencies: [i4.NgIf, i5.RouterLink, i3$1.FeatureDirective, i4.AsyncPipe, i3$1.TranslatePipe, i3$1.UrlPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddToSavedCartComponent, [{
    type: Component,
    args: [{
      selector: 'cx-add-to-saved-cart',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"cart$ | async as cart\">\n  <div class=\"cx-add-to-saved-cart-container\">\n    <a\n      class=\"link cx-action-link\"\n      [routerLink]=\"\n        {\n          cxRoute: 'savedCarts',\n        } | cxUrl\n      \"\n      cxAutoFocus\n    >\n      <span>{{ 'addToSavedCart.savedCarts' | cxTranslate }}</span>\n    </a>\n    <button\n      *cxFeature=\"'a11yUseButtonsForBtnLinks'\"\n      #element\n      class=\"link cx-action-link\"\n      [class.disabled]=\"disableSaveCartForLater$ | async\"\n      (click)=\"saveCart(cart)\"\n      cxAutoFocus\n    >\n      <span>{{ 'addToSavedCart.saveCartForLater' | cxTranslate }}</span>\n    </button>\n    <a\n      *cxFeature=\"'!a11yUseButtonsForBtnLinks'\"\n      #element\n      tabindex=\"0\"\n      class=\"link cx-action-link\"\n      [class.disabled]=\"disableSaveCartForLater$ | async\"\n      (click)=\"saveCart(cart)\"\n      cxAutoFocus\n    >\n      <span>{{ 'addToSavedCart.saveCartForLater' | cxTranslate }}</span>\n    </a>\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: i3.ActiveCartFacade
  }, {
    type: i3$1.AuthService
  }, {
    type: i3$1.RoutingService
  }, {
    type: i0.ViewContainerRef
  }, {
    type: i3$2.LaunchDialogService
  }], {
    element: [{
      type: ViewChild,
      args: ['element']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AddToSavedCartModule {
  static {
    this.ɵfac = function AddToSavedCartModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddToSavedCartModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AddToSavedCartModule,
      declarations: [AddToSavedCartComponent],
      imports: [CommonModule, RouterModule, I18nModule, UrlModule, FeaturesConfigModule],
      exports: [AddToSavedCartComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          AddToSavedCartsComponent: {
            component: AddToSavedCartComponent
          }
        }
      })],
      imports: [CommonModule, RouterModule, I18nModule, UrlModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddToSavedCartModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, I18nModule, UrlModule, FeaturesConfigModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          AddToSavedCartsComponent: {
            component: AddToSavedCartComponent
          }
        }
      })],
      exports: [AddToSavedCartComponent],
      declarations: [AddToSavedCartComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SavedCartDetailsService {
  constructor(routingService, savedCartService) {
    this.routingService = routingService;
    this.savedCartService = savedCartService;
    this.savedCartId$ = this.routingService.getRouterState().pipe(map(routingData => routingData.state.params.savedCartId), distinctUntilChanged());
    this.savedCart$ = this.savedCartId$.pipe(filter(cartId => Boolean(cartId)), tap(savedCartId => this.savedCartService.loadSavedCart(savedCartId)), switchMap(savedCartId => this.savedCartService.get(savedCartId)), shareReplay({
      bufferSize: 1,
      refCount: true
    }));
  }
  getSavedCartId() {
    return this.savedCartId$;
  }
  getCartDetails() {
    return this.savedCart$;
  }
  static {
    this.ɵfac = function SavedCartDetailsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SavedCartDetailsService)(i0.ɵɵinject(i3$1.RoutingService), i0.ɵɵinject(i2.SavedCartFacade));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SavedCartDetailsService,
      factory: SavedCartDetailsService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SavedCartDetailsService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i3$1.RoutingService
  }, {
    type: i2.SavedCartFacade
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SavedCartDetailsActionComponent {
  constructor(savedCartDetailsService, vcr, launchDialogService) {
    this.savedCartDetailsService = savedCartDetailsService;
    this.vcr = vcr;
    this.launchDialogService = launchDialogService;
    this.subscription = new Subscription();
    this.savedCartFormType = SavedCartFormType;
    this.savedCart$ = this.savedCartDetailsService.getCartDetails();
  }
  openDialog(cart, type) {
    const dialog = this.launchDialogService.openDialog("SAVED_CART" /* LAUNCH_CALLER.SAVED_CART */, this.element, this.vcr, {
      cart,
      layoutOption: type
    });
    if (dialog) {
      this.subscription.add(dialog.pipe(take(1)).subscribe());
    }
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  static {
    this.ɵfac = function SavedCartDetailsActionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SavedCartDetailsActionComponent)(i0.ɵɵdirectiveInject(SavedCartDetailsService), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i3$2.LaunchDialogService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SavedCartDetailsActionComponent,
      selectors: [["cx-saved-cart-details-action"]],
      viewQuery: function SavedCartDetailsActionComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.element = _t.first);
        }
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["element", ""], [4, "ngIf"], [1, "cx-saved-cart-restore-btns", "row"], [1, "col-xs-12", "col-md-5", "col-lg-4"], [1, "btn", "btn-block", "btn-secondary", 3, "click"], [1, "btn", "btn-block", "btn-primary", 3, "click"]],
      template: function SavedCartDetailsActionComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, SavedCartDetailsActionComponent_ng_container_0_Template, 12, 6, "ng-container", 1);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.savedCart$));
        }
      },
      dependencies: [i4.NgIf, i4.AsyncPipe, i3$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SavedCartDetailsActionComponent, [{
    type: Component,
    args: [{
      selector: 'cx-saved-cart-details-action',
      standalone: false,
      template: "<ng-container *ngIf=\"savedCart$ | async as cart\">\n  <div class=\"cx-saved-cart-restore-btns row\">\n    <div class=\"col-xs-12 col-md-5 col-lg-4\">\n      <button\n        #element\n        class=\"btn btn-block btn-secondary\"\n        (click)=\"openDialog(cart, savedCartFormType.DELETE)\"\n      >\n        {{ 'savedCartDetails.deleteSavedCart' | cxTranslate }}\n      </button>\n    </div>\n    <div class=\"col-xs-12 col-md-5 col-lg-4\">\n      <button\n        #element\n        class=\"btn btn-block btn-primary\"\n        (click)=\"openDialog(cart, savedCartFormType.RESTORE)\"\n      >\n        {{ 'savedCartList.makeCartActive' | cxTranslate }}\n      </button>\n    </div>\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: SavedCartDetailsService
  }, {
    type: i0.ViewContainerRef
  }, {
    type: i3$2.LaunchDialogService
  }], {
    element: [{
      type: ViewChild,
      args: ['element']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SavedCartDetailsItemsComponent {
  constructor(savedCartDetailsService, savedCartService, eventSercvice, globalMessageService, routingService, translation) {
    this.savedCartDetailsService = savedCartDetailsService;
    this.savedCartService = savedCartService;
    this.eventSercvice = eventSercvice;
    this.globalMessageService = globalMessageService;
    this.routingService = routingService;
    this.translation = translation;
    this.subscription = new Subscription();
    this.CartOutlets = CartOutlets;
    this.CartType = CartType;
    this.CartLocation = PromotionLocation;
    this.cartLoaded$ = this.savedCartDetailsService.getSavedCartId().pipe(switchMap(cartId => this.savedCartService.isStable(cartId)));
    this.savedCart$ = this.savedCartDetailsService.getCartDetails().pipe(tap(cart => {
      if ((cart?.entries ?? []).length <= 0 && !!cart?.code) {
        this.savedCartService.deleteSavedCart(cart.code);
      }
    }));
  }
  ngOnInit() {
    this.subscription.add(this.eventSercvice.get(DeleteCartSuccessEvent).pipe(take(1), map(() => true)).subscribe(success => this.onDeleteComplete(success)));
    this.buyItAgainTranslation$ = this.translation.translate('addToCart.addToActiveCart');
  }
  onDeleteComplete(success) {
    if (success) {
      this.routingService.go({
        cxRoute: 'savedCarts'
      });
      this.globalMessageService.add({
        key: 'savedCartDialog.deleteCartSuccess'
      }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
    }
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  static {
    this.ɵfac = function SavedCartDetailsItemsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SavedCartDetailsItemsComponent)(i0.ɵɵdirectiveInject(SavedCartDetailsService), i0.ɵɵdirectiveInject(i2.SavedCartFacade), i0.ɵɵdirectiveInject(i3$1.EventService), i0.ɵɵdirectiveInject(i3$1.GlobalMessageService), i0.ɵɵdirectiveInject(i3$1.RoutingService), i0.ɵɵdirectiveInject(i3$1.TranslationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SavedCartDetailsItemsComponent,
      selectors: [["cx-saved-cart-details-items"]],
      standalone: false,
      decls: 6,
      vars: 3,
      consts: [["emptyCartItems", ""], ["addToCartBtn", ""], [4, "ngIf"], [4, "ngIf", "ngIfElse"], ["role", "status", 4, "cxFeature"], [1, "cart-details-wrapper"], [3, "cxOutlet", "cxOutletContext"], ["role", "status"], [1, "cx-spinner"], [3, "productCode", "product", "showQuantity", "options", "pickupStore"]],
      template: function SavedCartDetailsItemsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, SavedCartDetailsItemsComponent_ng_container_0_Template, 2, 2, "ng-container", 2);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, SavedCartDetailsItemsComponent_ng_template_2_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, SavedCartDetailsItemsComponent_ng_template_4_Template, 1, 5, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.savedCart$));
        }
      },
      dependencies: [i4.NgIf, i3$2.SpinnerComponent, i3$2.OutletDirective, i6.AddToCartComponent, i3$1.FeatureDirective, i4.AsyncPipe, i3$1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SavedCartDetailsItemsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-saved-cart-details-items',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"savedCart$ | async as cart\">\n  <ng-container *ngIf=\"cart?.entries?.length > 0; else emptyCartItems\">\n    <div\n      *cxFeature=\"'!a11yRemoveStatusLoadedRole'\"\n      role=\"status\"\n      [attr.aria-label]=\"'common.loaded' | cxTranslate\"\n    ></div>\n    <div class=\"cart-details-wrapper\">\n      <ng-template\n        [cxOutlet]=\"CartOutlets.CART_ITEM_LIST\"\n        [cxOutletContext]=\"{\n          cartId: cart.code,\n          cartIsLoading: !(cartLoaded$ | async),\n          items: cart.entries,\n          promotionLocation: CartLocation.SavedCart,\n          options: {\n            displayAddToCart: true,\n            addToCartString: (buyItAgainTranslation$ | async),\n            optionalBtn: addToCartBtn,\n            cartType: CartType.SELECTIVE,\n          },\n        }\"\n      >\n      </ng-template>\n    </div>\n  </ng-container>\n</ng-container>\n<ng-template #emptyCartItems>\n  <div class=\"cx-spinner\">\n    <cx-spinner></cx-spinner>\n  </div>\n</ng-template>\n\n<ng-template let-ctx #addToCartBtn>\n  <cx-add-to-cart\n    [productCode]=\"ctx.item.product?.code\"\n    [product]=\"ctx.item.product\"\n    [showQuantity]=\"false\"\n    [options]=\"ctx.options\"\n    [pickupStore]=\"ctx.item.deliveryPointOfService?.name\"\n  >\n  </cx-add-to-cart>\n</ng-template>\n"
    }]
  }], () => [{
    type: SavedCartDetailsService
  }, {
    type: i2.SavedCartFacade
  }, {
    type: i3$1.EventService
  }, {
    type: i3$1.GlobalMessageService
  }, {
    type: i3$1.RoutingService
  }, {
    type: i3$1.TranslationService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SavedCartDetailsOverviewComponent {
  constructor(savedCartDetailsService, translation, vcr, launchDialogService) {
    this.savedCartDetailsService = savedCartDetailsService;
    this.translation = translation;
    this.vcr = vcr;
    this.launchDialogService = launchDialogService;
    this.subscription = new Subscription();
    this.iconTypes = ICON_TYPE;
    this.savedCart$ = this.savedCartDetailsService.getCartDetails();
  }
  getCartName(cartName) {
    return this.translation.translate('savedCartDetails.cartName').pipe(filter(() => Boolean(cartName)), map(textTitle => ({
      title: textTitle,
      text: [cartName]
    })));
  }
  getCartDescription(cartDescription) {
    return this.translation.translate('savedCartDetails.cartDescription').pipe(filter(() => Boolean(cartDescription)), map(textTitle => ({
      title: textTitle,
      text: [cartDescription]
    })));
  }
  getCartId(cartId) {
    return this.translation.translate('savedCartDetails.cartId').pipe(filter(() => Boolean(cartId)), map(textTitle => ({
      title: textTitle,
      text: [cartId]
    })));
  }
  getDateSaved(saveTime) {
    return this.translation.translate('savedCartDetails.dateSaved').pipe(filter(() => Boolean(saveTime)), map(textTitle => {
      return {
        title: textTitle,
        text: [saveTime ?? '']
      };
    }));
  }
  getCartItems(totalItems) {
    return this.translation.translate('savedCartDetails.items').pipe(filter(() => Boolean(totalItems)), map(textTitle => ({
      title: textTitle,
      text: [totalItems.toString()]
    })));
  }
  getCartQuantity(totalUnitCount) {
    return this.translation.translate('savedCartDetails.quantity').pipe(filter(() => Boolean(totalUnitCount)), map(textTitle => ({
      title: textTitle,
      text: [totalUnitCount.toString()]
    })));
  }
  getCartTotal(totalPriceWithTax) {
    return this.translation.translate('savedCartDetails.total').pipe(filter(() => Boolean(totalPriceWithTax)), map(textTitle => ({
      title: textTitle,
      text: [totalPriceWithTax]
    })));
  }
  openDialog(cart) {
    const dialog = this.launchDialogService.openDialog("SAVED_CART" /* LAUNCH_CALLER.SAVED_CART */, this.element, this.vcr, {
      cart,
      layoutOption: 'edit'
    });
    if (dialog) {
      this.subscription.add(dialog.pipe(take(1)).subscribe());
    }
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  static {
    this.ɵfac = function SavedCartDetailsOverviewComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SavedCartDetailsOverviewComponent)(i0.ɵɵdirectiveInject(SavedCartDetailsService), i0.ɵɵdirectiveInject(i3$1.TranslationService), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i3$2.LaunchDialogService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SavedCartDetailsOverviewComponent,
      selectors: [["cx-saved-cart-details-overview"]],
      viewQuery: function SavedCartDetailsOverviewComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.element = _t.first);
        }
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["element", ""], [4, "ngIf"], [1, "cx-cart-summary"], [1, "container"], [1, "cx-summary-card"], [1, "cx-edit-container"], [3, "content"], [1, "cx-edit-cart", 3, "click"], [3, "type"], [1, "cx-card-description"], [3, "content", "truncateText", "charactersLimit"]],
      template: function SavedCartDetailsOverviewComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, SavedCartDetailsOverviewComponent_ng_container_0_Template, 29, 32, "ng-container", 1);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.savedCart$));
        }
      },
      dependencies: [i4.NgIf, i3$2.CardComponent, i3$2.IconComponent, i4.AsyncPipe, i3$1.TranslatePipe, i3$1.CxDatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SavedCartDetailsOverviewComponent, [{
    type: Component,
    args: [{
      selector: 'cx-saved-cart-details-overview',
      standalone: false,
      template: "<ng-container *ngIf=\"savedCart$ | async as cart\">\n  <div class=\"cx-cart-summary\">\n    <div class=\"container\">\n      <div class=\"cx-summary-card\">\n        <div class=\"cx-edit-container\">\n          <cx-card [content]=\"getCartName(cart?.name) | async\"></cx-card>\n          <button\n            [attr.aria-label]=\"'savedCartDetails.editSavedCart' | cxTranslate\"\n            [attr.title]=\"'savedCartDetails.editSavedCart' | cxTranslate\"\n            class=\"cx-edit-cart\"\n            #element\n            (click)=\"openDialog(cart)\"\n          >\n            <cx-icon [type]=\"iconTypes.PENCIL\"></cx-icon>\n          </button>\n        </div>\n        <div class=\"cx-card-description\">\n          <cx-card\n            [content]=\"getCartDescription(cart?.description) | async\"\n            [truncateText]=\"true\"\n            [charactersLimit]=\"30\"\n          ></cx-card>\n        </div>\n      </div>\n      <div class=\"cx-summary-card\">\n        <cx-card [content]=\"getCartId(cart?.code) | async\"></cx-card>\n      </div>\n      <div class=\"cx-summary-card\">\n        <cx-card\n          [content]=\"getDateSaved(cart?.saveTime | cxDate) | async\"\n        ></cx-card>\n        <cx-card [content]=\"getCartItems(cart?.totalItems) | async\"></cx-card>\n      </div>\n      <div class=\"cx-summary-card\">\n        <cx-card\n          [content]=\"getCartQuantity(cart?.totalUnitCount) | async\"\n        ></cx-card>\n        <cx-card\n          [content]=\"\n            getCartTotal(cart?.totalPriceWithTax?.formattedValue) | async\n          \"\n        ></cx-card>\n      </div>\n    </div>\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: SavedCartDetailsService
  }, {
    type: i3$1.TranslationService
  }, {
    type: i0.ViewContainerRef
  }, {
    type: i3$2.LaunchDialogService
  }], {
    element: [{
      type: ViewChild,
      args: ['element']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SavedCartDetailsModule {
  static {
    this.ɵfac = function SavedCartDetailsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SavedCartDetailsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SavedCartDetailsModule,
      declarations: [SavedCartDetailsOverviewComponent, SavedCartDetailsActionComponent, SavedCartDetailsItemsComponent],
      imports: [CommonModule, I18nModule, UrlModule, RouterModule, CardModule, MediaModule, IconModule, SpinnerModule, OutletModule, AddToCartModule, i3$1.ConfigModule, FeaturesConfigModule],
      exports: [SavedCartDetailsOverviewComponent, SavedCartDetailsActionComponent, SavedCartDetailsItemsComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, I18nModule, UrlModule, RouterModule, CardModule, MediaModule, IconModule, SpinnerModule, OutletModule, AddToCartModule, ConfigModule.withConfig({
        cmsComponents: {
          SavedCartDetailsOverviewComponent: {
            component: SavedCartDetailsOverviewComponent,
            guards: [AuthGuard]
          },
          SavedCartDetailsItemsComponent: {
            component: SavedCartDetailsItemsComponent,
            guards: [AuthGuard]
          },
          SavedCartDetailsActionComponent: {
            component: SavedCartDetailsActionComponent,
            guards: [AuthGuard]
          }
        }
      }), FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SavedCartDetailsModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, I18nModule, UrlModule, RouterModule, CardModule, MediaModule, IconModule, SpinnerModule, OutletModule, AddToCartModule, ConfigModule.withConfig({
        cmsComponents: {
          SavedCartDetailsOverviewComponent: {
            component: SavedCartDetailsOverviewComponent,
            guards: [AuthGuard]
          },
          SavedCartDetailsItemsComponent: {
            component: SavedCartDetailsItemsComponent,
            guards: [AuthGuard]
          },
          SavedCartDetailsActionComponent: {
            component: SavedCartDetailsActionComponent,
            guards: [AuthGuard]
          }
        }
      }), FeaturesConfigModule],
      declarations: [SavedCartDetailsOverviewComponent, SavedCartDetailsActionComponent, SavedCartDetailsItemsComponent],
      exports: [SavedCartDetailsOverviewComponent, SavedCartDetailsActionComponent, SavedCartDetailsItemsComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SavedCartListComponent {
  constructor(routing, savedCartService, vcr, launchDialogService) {
    this.routing = routing;
    this.savedCartService = savedCartService;
    this.vcr = vcr;
    this.launchDialogService = launchDialogService;
    this.subscription = new Subscription();
    this.siteContextService = inject(SiteContextComponentService, {
      optional: true
    });
    this.savedCarts$ = this.savedCartService.getList().pipe(map(lists => lists.sort((a, b) => {
      const date1 = a.saveTime ? new Date(a.saveTime).getTime() : new Date().getTime();
      const date2 = b.saveTime ? new Date(b.saveTime).getTime() : new Date().getTime();
      return date2 - date1;
    })));
    useFeatureStyles('a11ySavedCartsZoom');
    useFeatureStyles('a11yQTY2Quantity');
    useFeatureStyles('a11yHighContrastBorders');
  }
  ngOnInit() {
    this.isLoading$ = this.savedCartService.getSavedCartListProcessLoading();
    this.savedCartService.loadSavedCarts();
    this.observeAndReloadSavedCartOnContextChange();
  }
  goToSavedCartDetails(cart) {
    this.routing.go({
      cxRoute: 'savedCartsDetails',
      params: {
        savedCartId: cart?.code
      }
    });
  }
  openDialog(event, cart) {
    const dialog = this.launchDialogService.openDialog("SAVED_CART" /* LAUNCH_CALLER.SAVED_CART */, this.restoreButton, this.vcr, {
      cart,
      layoutOption: SavedCartFormType.RESTORE
    });
    if (dialog) {
      this.subscription.add(dialog.pipe(take(1)).subscribe());
    }
    event.stopPropagation();
  }
  observeAndReloadSavedCartOnContextChange() {
    if (this.siteContextService) {
      const contexts = Object.values(SiteContextType);
      const siteContextService = this.siteContextService;
      if (!contexts.length) {
        return;
      }
      this.subscription.add(from(contexts).pipe(mergeMap(context => {
        return siteContextService.getActiveItem(context).pipe(skip(1));
      })).subscribe(() => {
        this.savedCartService.loadSavedCarts();
      }));
    }
  }
  ngOnDestroy() {
    this.savedCartService.clearSavedCarts();
    this.savedCartService.clearSaveCart();
    this.savedCartService.clearRestoreSavedCart();
    this.subscription?.unsubscribe();
  }
  static {
    this.ɵfac = function SavedCartListComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SavedCartListComponent)(i0.ɵɵdirectiveInject(i3$1.RoutingService), i0.ɵɵdirectiveInject(i2.SavedCartFacade), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i3$2.LaunchDialogService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SavedCartListComponent,
      selectors: [["cx-saved-cart-list"]],
      viewQuery: function SavedCartListComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.restoreButton = _t.first);
        }
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["loading", ""], ["noSavedCarts", ""], ["element", ""], [4, "ngIf"], [4, "ngIf", "ngIfElse"], ["role", "status", 4, "cxFeature"], [1, "cx-saved-cart-list-header"], ["role", "status"], ["role", "table", 1, "table", "cx-saved-cart-list-table"], ["role", "row", "class", "cx-saved-cart-list-thead-mobile", 4, "cxFeature"], ["role", "row", 3, "click", 4, "ngFor", "ngForOf"], ["role", "row", 1, "cx-saved-cart-list-thead-mobile"], ["role", "columnheader", "scope", "col"], ["role", "columnheader", "scope", "col", "class", "cx-saved-cart-list-th-qty", 4, "cxFeature"], ["role", "columnheader", "scope", "col", 1, "cx-saved-cart-list-th-total"], ["class", "cx-saved-cart-list-thead-mobile", 4, "cxFeature"], ["role", "columnheader", "scope", "col", 1, "cx-saved-cart-list-th-qty"], [1, "cx-saved-cart-list-thead-mobile"], ["scope", "col"], ["scope", "col", "class", "cx-saved-cart-list-th-qty", 4, "cxFeature"], ["scope", "col", 1, "cx-saved-cart-list-th-total"], ["scope", "col", 1, "cx-saved-cart-list-th-qty"], ["role", "row", 3, "click"], [1, "cx-saved-cart-list-cart-name"], [1, "cx-table-label-mobile", "cx-saved-cart-list-label"], [1, "cx-saved-cart-list-value", 3, "routerLink"], [1, "cx-saved-cart-list-cart-id"], [1, "cx-saved-cart-list-date-saved"], [1, "cx-saved-cart-list-quantity"], ["class", "cx-table-label-mobile cx-saved-cart-list-label", 4, "cxFeature"], [1, "cx-saved-cart-list-total"], [1, "cx-saved-cart-list-make-cart-active"], [1, "btn", "btn-tertiary", "cx-saved-cart-make-active", 3, "click"], [1, "cx-saved-cart-list-no-saved-carts", "row"], [1, "col-sm-12", "col-md-6", "col-lg-4"], [1, "cx-spinner"]],
      template: function SavedCartListComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, SavedCartListComponent_ng_container_0_Template, 5, 4, "ng-container", 3);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.savedCarts$));
        }
      },
      dependencies: [i4.NgForOf, i4.NgIf, i5.RouterLink, i3$2.SpinnerComponent, i3$1.FeatureDirective, i4.AsyncPipe, i3$1.UrlPipe, i3$1.TranslatePipe, i3$1.CxDatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SavedCartListComponent, [{
    type: Component,
    args: [{
      selector: 'cx-saved-cart-list',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"savedCarts$ | async as savedCarts\">\n  <ng-container *ngIf=\"!(isLoading$ | async); else loading\">\n    <div\n      *cxFeature=\"'!a11yRemoveStatusLoadedRole'\"\n      role=\"status\"\n      [attr.aria-label]=\"'common.loaded' | cxTranslate\"\n    ></div>\n    <div class=\"cx-saved-cart-list-header\">\n      <h2>\n        {{\n          'savedCartList.savedCarts' | cxTranslate: { count: savedCarts.length }\n        }}\n      </h2>\n    </div>\n\n    <ng-container *ngIf=\"savedCarts?.length > 0; else noSavedCarts\">\n      <table role=\"table\" class=\"table cx-saved-cart-list-table\">\n        <thead\n          *cxFeature=\"'!a11yTableHeaderReadout'\"\n          role=\"row\"\n          class=\"cx-saved-cart-list-thead-mobile\"\n        >\n          <thead role=\"row\" class=\"cx-saved-cart-list-thead-mobile\">\n            <th role=\"columnheader\" scope=\"col\">\n              {{ 'savedCartList.cartName' | cxTranslate }}\n            </th>\n            <th role=\"columnheader\" scope=\"col\">\n              {{ 'savedCartList.cartId' | cxTranslate }}\n            </th>\n            <th role=\"columnheader\" scope=\"col\">\n              {{ 'savedCartList.dateSaved' | cxTranslate }}\n            </th>\n            <th\n              *cxFeature=\"'a11yQTY2Quantity'\"\n              role=\"columnheader\"\n              scope=\"col\"\n              class=\"cx-saved-cart-list-th-qty\"\n            >\n              {{ 'savedCartList.quantityFull' | cxTranslate }}\n            </th>\n            <th\n              *cxFeature=\"'!a11yQTY2Quantity'\"\n              role=\"columnheader\"\n              scope=\"col\"\n              class=\"cx-saved-cart-list-th-qty\"\n            >\n              {{ 'savedCartList.quantity' | cxTranslate }}\n            </th>\n            <th\n              role=\"columnheader\"\n              scope=\"col\"\n              class=\"cx-saved-cart-list-th-total\"\n            >\n              {{ 'savedCartList.total' | cxTranslate }}\n            </th>\n            <th role=\"columnheader\" scope=\"col\">\n              {{ 'savedCartList.actions' | cxTranslate }}\n            </th>\n          </thead>\n          <thead\n            *cxFeature=\"'a11yTableHeaderReadout'\"\n            class=\"cx-saved-cart-list-thead-mobile\"\n          >\n            <tr>\n              <th scope=\"col\">\n                {{ 'savedCartList.cartName' | cxTranslate }}\n              </th>\n              <th scope=\"col\">\n                {{ 'savedCartList.cartId' | cxTranslate }}\n              </th>\n              <th scope=\"col\">\n                {{ 'savedCartList.dateSaved' | cxTranslate }}\n              </th>\n              <th\n                *cxFeature=\"'a11yQTY2Quantity'\"\n                scope=\"col\"\n                class=\"cx-saved-cart-list-th-qty\"\n              >\n                {{ 'savedCartList.quantityFull' | cxTranslate }}\n              </th>\n              <th\n                *cxFeature=\"'!a11yQTY2Quantity'\"\n                scope=\"col\"\n                class=\"cx-saved-cart-list-th-qty\"\n              >\n                {{ 'savedCartList.quantity' | cxTranslate }}\n              </th>\n              <th scope=\"col\" class=\"cx-saved-cart-list-th-total\">\n                {{ 'savedCartList.total' | cxTranslate }}\n              </th>\n              <th scope=\"col\">\n                {{ 'savedCartList.actions' | cxTranslate }}\n              </th>\n            </tr>\n          </thead>\n        </thead>\n        <tbody>\n          <tr\n            role=\"row\"\n            *ngFor=\"let savedCart of savedCarts\"\n            (click)=\"goToSavedCartDetails(savedCart)\"\n          >\n            <td class=\"cx-saved-cart-list-cart-name\">\n              <div class=\"cx-table-label-mobile cx-saved-cart-list-label\">\n                {{ 'savedCartList.cartName' | cxTranslate }}\n              </div>\n              <a\n                [routerLink]=\"\n                  {\n                    cxRoute: 'savedCartsDetails',\n                    params: { savedCartId: savedCart?.code },\n                  } | cxUrl\n                \"\n                class=\"cx-saved-cart-list-value\"\n              >\n                {{ savedCart?.name }}</a\n              >\n            </td>\n            <td class=\"cx-saved-cart-list-cart-id\">\n              <div class=\"cx-table-label-mobile cx-saved-cart-list-label\">\n                {{ 'savedCartList.cartId' | cxTranslate }}\n              </div>\n              <a\n                [routerLink]=\"\n                  {\n                    cxRoute: 'savedCartsDetails',\n                    params: { savedCartId: savedCart?.code },\n                  } | cxUrl\n                \"\n                class=\"cx-saved-cart-list-value\"\n                >{{ savedCart?.code }}</a\n              >\n            </td>\n            <td class=\"cx-saved-cart-list-date-saved\">\n              <div class=\"cx-table-label-mobile cx-saved-cart-list-label\">\n                {{ 'savedCartList.dateSaved' | cxTranslate }}\n              </div>\n              <a\n                [routerLink]=\"\n                  {\n                    cxRoute: 'savedCartsDetails',\n                    params: { savedCartId: savedCart?.code },\n                  } | cxUrl\n                \"\n                class=\"cx-saved-cart-list-value\"\n                >{{ savedCart?.saveTime | cxDate: 'longDate' }}</a\n              >\n            </td>\n            <td class=\"cx-saved-cart-list-quantity\">\n              <div\n                *cxFeature=\"'a11yQTY2Quantity'\"\n                class=\"cx-table-label-mobile cx-saved-cart-list-label\"\n              >\n                {{ 'savedCartList.quantityFull' | cxTranslate }}\n              </div>\n              <div\n                *cxFeature=\"'!a11yQTY2Quantity'\"\n                class=\"cx-table-label-mobile cx-saved-cart-list-label\"\n              >\n                {{ 'savedCartList.quantity' | cxTranslate }}\n              </div>\n              <a\n                [routerLink]=\"\n                  {\n                    cxRoute: 'savedCartsDetails',\n                    params: { savedCartId: savedCart?.code },\n                  } | cxUrl\n                \"\n                class=\"cx-saved-cart-list-value\"\n              >\n                {{ savedCart?.totalUnitCount }}</a\n              >\n            </td>\n            <td class=\"cx-saved-cart-list-total\">\n              <div class=\"cx-table-label-mobile cx-saved-cart-list-label\">\n                {{ 'savedCartList.total' | cxTranslate }}\n              </div>\n              <a\n                [routerLink]=\"\n                  {\n                    cxRoute: 'savedCartsDetails',\n                    params: { savedCartId: savedCart?.code },\n                  } | cxUrl\n                \"\n                class=\"cx-saved-cart-list-value\"\n              >\n                {{ savedCart?.totalPrice?.formattedValue }}</a\n              >\n            </td>\n            <td class=\"cx-saved-cart-list-make-cart-active\">\n              <div class=\"cx-table-label-mobile cx-saved-cart-list-label\">\n                {{ 'savedCartList.actions' | cxTranslate }}\n              </div>\n              <button\n                #element\n                class=\"btn btn-tertiary cx-saved-cart-make-active\"\n                (click)=\"openDialog($event, savedCart)\"\n              >\n                {{ 'savedCartList.makeCartActive' | cxTranslate }}\n              </button>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </ng-container>\n\n    <!-- NO SAVED CART CONTAINER -->\n    <ng-template #noSavedCarts>\n      <div class=\"cx-saved-cart-list-no-saved-carts row\">\n        <div class=\"col-sm-12 col-md-6 col-lg-4\">\n          <div>{{ 'savedCartList.notFound' | cxTranslate }}</div>\n        </div>\n      </div>\n    </ng-template>\n  </ng-container>\n\n  <ng-template #loading>\n    <div class=\"cx-spinner\">\n      <cx-spinner></cx-spinner>\n    </div>\n  </ng-template>\n</ng-container>\n"
    }]
  }], () => [{
    type: i3$1.RoutingService
  }, {
    type: i2.SavedCartFacade
  }, {
    type: i0.ViewContainerRef
  }, {
    type: i3$2.LaunchDialogService
  }], {
    restoreButton: [{
      type: ViewChild,
      args: ['element']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SavedCartListModule {
  static {
    this.ɵfac = function SavedCartListModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SavedCartListModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SavedCartListModule,
      declarations: [SavedCartListComponent],
      imports: [CommonModule, UrlModule, RouterModule, ListNavigationModule, I18nModule, SpinnerModule, FeaturesConfigModule],
      exports: [SavedCartListComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          AccountSavedCartHistoryComponent: {
            component: SavedCartListComponent,
            guards: [AuthGuard]
          }
        }
      })],
      imports: [CommonModule, UrlModule, RouterModule, ListNavigationModule, I18nModule, SpinnerModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SavedCartListModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, UrlModule, RouterModule, ListNavigationModule, I18nModule, SpinnerModule, FeaturesConfigModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          AccountSavedCartHistoryComponent: {
            component: SavedCartListComponent,
            guards: [AuthGuard]
          }
        }
      })],
      declarations: [SavedCartListComponent],
      exports: [SavedCartListComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SavedCartOrderEntriesContext {
  constructor(importInfoService, userIdService, multiCartService, savedCartService, routingService) {
    this.importInfoService = importInfoService;
    this.userIdService = userIdService;
    this.multiCartService = multiCartService;
    this.savedCartService = savedCartService;
    this.routingService = routingService;
    this.type = OrderEntriesSource.SAVED_CART;
    this.savedCartId$ = this.routingService.getRouterState().pipe(map(routingData => routingData.state.params.savedCartId), distinctUntilChanged());
  }
  addEntries(products) {
    return this.add(products).pipe(switchMap(cartId => this.importInfoService.getResults(cartId)), take(products.length));
  }
  getEntries() {
    return this.savedCartId$.pipe(switchMap(cartId => this.savedCartService.get(cartId)), map(cart => cart?.entries ?? []));
  }
  add(products) {
    return combineLatest([this.userIdService.takeUserId(), this.savedCartId$]).pipe(tap(([userId, cartId]) => this.multiCartService.addEntries(userId, cartId, products)), map(([_userId, cartId]) => cartId));
  }
  static {
    this.ɵfac = function SavedCartOrderEntriesContext_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SavedCartOrderEntriesContext)(i0.ɵɵinject(i1.ProductImportInfoService), i0.ɵɵinject(i3$1.UserIdService), i0.ɵɵinject(i3.MultiCartFacade), i0.ɵɵinject(i2.SavedCartFacade), i0.ɵɵinject(i3$1.RoutingService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SavedCartOrderEntriesContext,
      factory: SavedCartOrderEntriesContext.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SavedCartOrderEntriesContext, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.ProductImportInfoService
  }, {
    type: i3$1.UserIdService
  }, {
    type: i3.MultiCartFacade
  }, {
    type: i2.SavedCartFacade
  }, {
    type: i3$1.RoutingService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class NewSavedCartOrderEntriesContext {
  constructor(importInfoService, userIdService, multiCartService, savedCartService) {
    this.importInfoService = importInfoService;
    this.userIdService = userIdService;
    this.multiCartService = multiCartService;
    this.savedCartService = savedCartService;
    this.type = OrderEntriesSource.NEW_SAVED_CART;
  }
  addEntries(products, savedCartInfo) {
    return this.add(products, savedCartInfo).pipe(tap(cartId => {
      this.importInfoService.getResults(cartId).pipe(take(products.length), every(productInfo => productInfo.statusCode === ProductImportStatus.UNKNOWN_IDENTIFIER || productInfo.statusCode === ProductImportStatus.UNKNOWN_ERROR)).subscribe(isInvalid => {
        if (isInvalid) {
          this.savedCartService.deleteSavedCart(cartId);
        }
      });
    }), switchMap(cartId => this.importInfoService.getResults(cartId)), take(products.length));
  }
  add(products, savedCartInfo) {
    return this.userIdService.takeUserId().pipe(switchMap(userId => this.multiCartService.createCart({
      userId,
      extraData: {
        active: false
      }
    }).pipe(map(cart => cart.code), tap(cartId => {
      this.savedCartService.saveCart({
        cartId,
        saveCartName: savedCartInfo?.name,
        saveCartDescription: savedCartInfo?.description
      });
      this.savedCartService.loadSavedCarts();
    }), observeOn(queueScheduler), debounce(() => this.savedCartService.getSaveCartProcessLoading().pipe(filter(loading => !loading))), tap(cartId => this.multiCartService.addEntries(userId, cartId, products)))));
  }
  static {
    this.ɵfac = function NewSavedCartOrderEntriesContext_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NewSavedCartOrderEntriesContext)(i0.ɵɵinject(i1.ProductImportInfoService), i0.ɵɵinject(i3$1.UserIdService), i0.ɵɵinject(i3.MultiCartFacade), i0.ɵɵinject(i2.SavedCartFacade));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: NewSavedCartOrderEntriesContext,
      factory: NewSavedCartOrderEntriesContext.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NewSavedCartOrderEntriesContext, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.ProductImportInfoService
  }, {
    type: i3$1.UserIdService
  }, {
    type: i3.MultiCartFacade
  }, {
    type: i2.SavedCartFacade
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SavedCartFormDialogComponent {
  get descriptionsCharacterLeft() {
    return this.descriptionMaxLength - (this.form.get('description')?.value?.length || 0);
  }
  handleClick(event) {
    // Close on click outside the dialog window
    if (event.target.tagName === this.el.nativeElement.tagName) {
      this.close('Cross click');
    }
  }
  constructor(launchDialogService, el, savedCartService, eventService, routingService, globalMessageService) {
    this.launchDialogService = launchDialogService;
    this.el = el;
    this.savedCartService = savedCartService;
    this.eventService = eventService;
    this.routingService = routingService;
    this.globalMessageService = globalMessageService;
    this.subscription = new Subscription();
    this.savedCartFormType = SavedCartFormType;
    this.iconTypes = ICON_TYPE;
    this.descriptionMaxLength = 250;
    this.nameMaxLength = 50;
    this.isCloneSavedCart = false;
    this.focusConfig = {
      trap: true,
      block: true,
      autofocus: 'button',
      focusOnEscape: true
    };
    useFeatureStyles('a11yVisibleFocusOverflows');
    useFeatureStyles('a11yQTY2Quantity');
  }
  ngOnInit() {
    this.resetSavedCartStates();
    this.isLoading$ = this.savedCartService.getSaveCartProcessLoading();
    this.isDisableDeleteButton$ = merge(this.eventService.get(DeleteCartEvent).pipe(take(1), map(() => true)), this.eventService.get(DeleteCartFailEvent).pipe(take(1), map(() => false)));
    this.isDisableRestoreButton$ = combineLatest([this.savedCartService.getCloneSavedCartProcessLoading(), this.savedCartService.getRestoreSavedCartProcessLoading()]).pipe(map(([isCloneLoading, isRestoreLoading]) => isCloneLoading || isRestoreLoading));
    this.subscription.add(this.launchDialogService.data$.subscribe(data => {
      this.cart = data.cart;
      this.layoutOption = data.layoutOption;
      this.build(this.cart);
    }));
    this.subscription.add(this.savedCartService.getSaveCartProcessSuccess().subscribe(success => this.onComplete(success)));
    this.subscription.add(this.eventService.get(DeleteCartSuccessEvent).pipe(take(1), map(() => true)).subscribe(success => this.onComplete(success)));
    this.subscription.add(this.savedCartService.getRestoreSavedCartProcessSuccess().subscribe(success => this.onComplete(success)));
  }
  saveOrEditCart(cartId) {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      FormUtils.deepUpdateValueAndValidity(this.form);
    } else {
      const name = this.form.get('name')?.value;
      // TODO(#12660): Remove default value once backend is updated
      const description = this.form.get('description')?.value || '-';
      switch (this.layoutOption) {
        case SavedCartFormType.SAVE:
          {
            this.savedCartService.saveCart({
              cartId,
              saveCartName: name,
              saveCartDescription: description
            });
            break;
          }
        case SavedCartFormType.EDIT:
          {
            this.savedCartService.editSavedCart({
              cartId,
              saveCartName: name,
              saveCartDescription: description
            });
            break;
          }
      }
    }
  }
  deleteCart(cartId) {
    this.savedCartService.deleteSavedCart(cartId);
  }
  restoreSavedCart(cartId) {
    if (this.isCloneSavedCart) {
      this.savedCartService.cloneSavedCart(cartId, this.form.get('cloneName')?.value);
    } else {
      this.savedCartService.restoreSavedCart(cartId);
    }
  }
  close(reason) {
    this.launchDialogService.closeDialog(reason);
  }
  onComplete(success) {
    if (success) {
      switch (this.layoutOption) {
        case SavedCartFormType.DELETE:
          {
            this.routingService.go({
              cxRoute: 'savedCarts'
            });
            this.globalMessageService.add({
              key: 'savedCartDialog.deleteCartSuccess'
            }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
            this.close('Successfully deleted a saved cart');
            break;
          }
        case SavedCartFormType.SAVE:
          {
            this.close('Successfully saved cart');
            this.savedCartService.clearSaveCart();
            this.globalMessageService.add({
              key: 'savedCartCartPage.messages.cartSaved',
              params: {
                cartName: this.form.get('name')?.value || this.cart?.code
              }
            }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
            break;
          }
        case SavedCartFormType.EDIT:
          {
            this.close('Successfully edited saved cart');
            this.savedCartService.clearSaveCart();
            this.globalMessageService.add({
              key: 'savedCartDialog.editCartSuccess',
              params: {
                cartName: this.form.get('name')?.value || this.cart?.code
              }
            }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
            break;
          }
        case SavedCartFormType.RESTORE:
          {
            this.close('Successfully restored saved cart');
            this.routingService.go({
              cxRoute: 'savedCarts'
            });
            this.resetSavedCartStates();
            break;
          }
      }
    }
  }
  toggleIsCloneSavedCart() {
    return this.isCloneSavedCart = !this.isCloneSavedCart;
  }
  build(cart) {
    const form = new UntypedFormGroup({});
    form.setControl('name', new UntypedFormControl('', [Validators.required, Validators.maxLength(this.nameMaxLength)]));
    form.setControl('description', new UntypedFormControl('', [Validators.maxLength(this.descriptionMaxLength)]));
    form.setControl('isCloneSavedCart', new UntypedFormControl(''));
    form.setControl('cloneName', new UntypedFormControl(''));
    this.form = form;
    this.patchData(cart);
  }
  patchData(item) {
    this.form.patchValue({
      ...item
    });
  }
  resetSavedCartStates() {
    this.savedCartService.clearCloneSavedCart();
    this.savedCartService.clearSaveCart();
    this.savedCartService.clearRestoreSavedCart();
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
    this.close('close dialog');
  }
  static {
    this.ɵfac = function SavedCartFormDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SavedCartFormDialogComponent)(i0.ɵɵdirectiveInject(i3$2.LaunchDialogService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.SavedCartFacade), i0.ɵɵdirectiveInject(i3$1.EventService), i0.ɵɵdirectiveInject(i3$1.RoutingService), i0.ɵɵdirectiveInject(i3$1.GlobalMessageService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SavedCartFormDialogComponent,
      selectors: [["cx-saved-cart-form-dialog"]],
      hostBindings: function SavedCartFormDialogComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function SavedCartFormDialogComponent_click_HostBindingHandler($event) {
            return ctx.handleClick($event);
          });
        }
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [["saveAndEditCart", ""], ["isRestoreSavedCart", ""], [4, "ngIf"], ["role", "dialog", "aria-labelledby", "dialogTitle", 1, "modal-dialog", "modal-dialog-centered", "cx-saved-cart-form-dialog", 3, "esc", "cxFocus"], [1, "modal-content", "cx-saved-cart-form-container", 3, "formGroup"], [1, "modal-header", "cx-saved-cart-form-header"], [3, "ngSwitch"], ["id", "dialogTitle", "class", "cx-saved-cart-form-title modal-title", 4, "cxFeature"], ["type", "button", 1, "cx-saved-cart-form-close", "close", 3, "click", "disabled", "title"], ["aria-hidden", "true"], [3, "type"], [1, "modal-body", "cx-saved-cart-form-body"], [4, "ngIf", "ngIfElse"], ["id", "dialogTitle", 1, "cx-saved-cart-form-title", "modal-title"], [4, "ngSwitchCase"], [1, "cx-saved-cart-form-subtitle"], [1, "cx-saved-cart-form-row"], [1, "cx-saved-cart-values-container"], [1, "cx-saved-cart-label"], [1, "cx-saved-cart-value"], ["class", "cx-saved-cart-label", 4, "cxFeature"], [1, "cx-saved-cart-form-footer"], ["type", "button", 1, "mr-2", "btn", "btn-secondary", 3, "click"], [1, "cx-copy-saved-cart-row", "form-check"], ["id", "cx-copy-saved-cart", "type", "checkbox", 1, "cx-copy-saved-cart-input", 3, "change", "checked"], ["for", "cx-copy-saved-cart", 1, "cx-copy-saved-cart-label"], ["class", "cx-copy-saved-cart-row", 4, "ngIf"], [1, "cx-copy-saved-cart-row"], [1, "label-content"], ["formControlName", "cloneName", "type", "text", 1, "form-control", 3, "maxLength", "placeholder"], ["class", "ml-2 btn btn-primary", "type", "button", 3, "disabled", "click", 4, "ngIf"], ["type", "button", 1, "ml-2", "btn", "btn-primary", 3, "click", "disabled"], [1, "cx-saved-carts-label", "label-content"], ["aria-hidden", "true", "class", "text-decoration-none required-asterisk", 3, "title", 4, "cxFeature"], ["required", "true", "formControlName", "name", "required", "", "type", "text", 1, "form-control", 3, "maxLength"], ["id", "nameError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], [1, "cx-saved-carts-label-optional"], ["formControlName", "description", "rows", "5", 1, "form-control", 3, "maxLength"], ["id", "descriptionError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], [1, "cx-saved-carts-input-hint"], ["type", "button", 1, "btn", "btn-secondary", 3, "click", "disabled"], ["type", "button", 1, "btn", "btn-primary", 3, "click", "disabled"], ["class", "form-legend", 4, "cxFeature"], [1, "form-legend"], ["aria-hidden", "true", 1, "text-decoration-none", "required-asterisk", 3, "title"], ["id", "nameError", "aria-live", "off", 3, "translationParams", "control"], [3, "control"], ["id", "descriptionError", "aria-live", "off", 3, "translationParams", "control"]],
      template: function SavedCartFormDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, SavedCartFormDialogComponent_ng_container_0_Template, 17, 17, "ng-container", 2);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.cart);
        }
      },
      dependencies: [i4.NgIf, i4.NgSwitch, i4.NgSwitchCase, i5$1.ɵNgNoValidate, i5$1.DefaultValueAccessor, i5$1.NgControlStatus, i5$1.NgControlStatusGroup, i5$1.RequiredValidator, i5$1.FormGroupDirective, i5$1.FormControlName, i3$2.FormErrorsComponent, i3$2.IconComponent, i3$2.FocusDirective, i3$1.FeatureDirective, i4.AsyncPipe, i3$1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SavedCartFormDialogComponent, [{
    type: Component,
    args: [{
      selector: 'cx-saved-cart-form-dialog',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"cart\">\n  <div\n    [cxFocus]=\"focusConfig\"\n    (esc)=\"close('Escape clicked')\"\n    class=\"modal-dialog modal-dialog-centered cx-saved-cart-form-dialog\"\n    role=\"dialog\"\n    aria-labelledby=\"dialogTitle\"\n  >\n    <form [formGroup]=\"form\" class=\"modal-content cx-saved-cart-form-container\">\n      <!-- Modal Header -->\n      <div class=\"modal-header cx-saved-cart-form-header\">\n        <ng-container [ngSwitch]=\"layoutOption\">\n          <h3\n            *cxFeature=\"'a11yDialogsHeading'\"\n            id=\"dialogTitle\"\n            class=\"cx-saved-cart-form-title modal-title\"\n          >\n            <ng-container *ngSwitchCase=\"savedCartFormType.EDIT\">\n              {{ 'savedCartDialog.editSavedCart' | cxTranslate }}\n            </ng-container>\n            <ng-container *ngSwitchCase=\"savedCartFormType.DELETE\">\n              {{ 'savedCartDialog.deleteSavedCart' | cxTranslate }}\n            </ng-container>\n            <ng-container *ngSwitchCase=\"savedCartFormType.SAVE\">\n              {{ 'savedCartDialog.saveForLater' | cxTranslate }}\n            </ng-container>\n            <ng-container *ngSwitchCase=\"savedCartFormType.RESTORE\">\n              {{ 'savedCartDialog.restoreSavedCart' | cxTranslate }}\n            </ng-container>\n          </h3>\n          <div\n            *cxFeature=\"'!a11yDialogsHeading'\"\n            id=\"dialogTitle\"\n            class=\"cx-saved-cart-form-title modal-title\"\n          >\n            <ng-container *ngSwitchCase=\"savedCartFormType.EDIT\">\n              {{ 'savedCartDialog.editSavedCart' | cxTranslate }}\n            </ng-container>\n            <ng-container *ngSwitchCase=\"savedCartFormType.DELETE\">\n              {{ 'savedCartDialog.deleteSavedCart' | cxTranslate }}\n            </ng-container>\n            <ng-container *ngSwitchCase=\"savedCartFormType.SAVE\">\n              {{ 'savedCartDialog.saveForLater' | cxTranslate }}\n            </ng-container>\n            <ng-container *ngSwitchCase=\"savedCartFormType.RESTORE\">\n              {{ 'savedCartDialog.restoreSavedCart' | cxTranslate }}\n            </ng-container>\n          </div>\n        </ng-container>\n\n        <button\n          (click)=\"close('Close Save Cart Dialog')\"\n          [disabled]=\"isLoading$ | async\"\n          class=\"cx-saved-cart-form-close close\"\n          type=\"button\"\n          title=\"{{ 'common.close' | cxTranslate }}\"\n          [attr.aria-label]=\"'common.close' | cxTranslate\"\n        >\n          <span aria-hidden=\"true\">\n            <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n          </span>\n        </button>\n      </div>\n\n      <!-- Modal Body -->\n      <div class=\"modal-body cx-saved-cart-form-body\">\n        <!-- start DELETE and RESTORE form -->\n        <ng-container\n          *ngIf=\"\n            layoutOption === savedCartFormType.DELETE ||\n              layoutOption === savedCartFormType.RESTORE;\n            else saveAndEditCart\n          \"\n        >\n          <p class=\"cx-saved-cart-form-subtitle\">\n            {{\n              (layoutOption === savedCartFormType.DELETE\n                ? 'savedCartDialog.followingCartDelete'\n                : 'savedCartDialog.followingCartRestore'\n              ) | cxTranslate\n            }}\n          </p>\n\n          <div class=\"cx-saved-cart-form-row\">\n            <div class=\"cx-saved-cart-values-container\">\n              <div class=\"cx-saved-cart-label\">\n                {{ 'savedCartDialog.name' | cxTranslate }}\n              </div>\n              <div class=\"cx-saved-cart-value\">\n                {{ cart?.name }}\n              </div>\n            </div>\n\n            <div class=\"cx-saved-cart-values-container\">\n              <div class=\"cx-saved-cart-label\">\n                {{ 'savedCartDialog.id' | cxTranslate }}\n              </div>\n              <div class=\"cx-saved-cart-value\">\n                {{ cart?.code }}\n              </div>\n            </div>\n\n            <div class=\"cx-saved-cart-values-container\">\n              <div class=\"cx-saved-cart-label\">\n                {{ 'savedCartDialog.description' | cxTranslate }}\n              </div>\n              <div class=\"cx-saved-cart-value\">\n                {{ cart?.description }}\n              </div>\n            </div>\n\n            <div class=\"cx-saved-cart-values-container\">\n              <div *cxFeature=\"'a11yQTY2Quantity'\" class=\"cx-saved-cart-label\">\n                {{ 'savedCartDialog.quantityFull' | cxTranslate }}\n              </div>\n              <div *cxFeature=\"'!a11yQTY2Quantity'\" class=\"cx-saved-cart-label\">\n                {{ 'savedCartDialog.quantity' | cxTranslate }}\n              </div>\n              <div class=\"cx-saved-cart-value\">\n                {{ cart?.totalUnitCount }}\n              </div>\n            </div>\n\n            <div class=\"cx-saved-cart-values-container\">\n              <div class=\"cx-saved-cart-label\">\n                {{ 'savedCartDialog.total' | cxTranslate }}\n              </div>\n              <div class=\"cx-saved-cart-value\">\n                {{ cart?.totalPriceWithTax?.formattedValue }}\n              </div>\n            </div>\n          </div>\n\n          <ng-container *ngIf=\"layoutOption === savedCartFormType.RESTORE\">\n            <div class=\"cx-copy-saved-cart-row form-check\">\n              <input\n                id=\"cx-copy-saved-cart\"\n                type=\"checkbox\"\n                class=\"cx-copy-saved-cart-input\"\n                [checked]=\"isCloneSavedCart\"\n                (change)=\"toggleIsCloneSavedCart()\"\n              />\n              <label\n                for=\"cx-copy-saved-cart\"\n                class=\"cx-copy-saved-cart-label\"\n                >{{ 'savedCartDialog.keepCopySavedCart' | cxTranslate }}</label\n              >\n            </div>\n\n            <div *ngIf=\"isCloneSavedCart\" class=\"cx-copy-saved-cart-row\">\n              <label>\n                <span class=\"label-content\">\n                  {{ 'savedCartDialog.nameOfCloneCart' | cxTranslate }}\n                </span>\n\n                <input\n                  [maxLength]=\"nameMaxLength\"\n                  class=\"form-control\"\n                  formControlName=\"cloneName\"\n                  type=\"text\"\n                  placeholder=\"{{\n                    'savedCartDialog.defaultCloneCartName'\n                      | cxTranslate: { name: form.get('name')?.value }\n                  }}\"\n                />\n              </label>\n            </div>\n          </ng-container>\n\n          <div class=\"cx-saved-cart-form-footer\">\n            <button\n              (click)=\"close('Close Save Cart Dialog')\"\n              class=\"mr-2 btn btn-secondary\"\n              type=\"button\"\n            >\n              {{ 'savedCartDialog.cancel' | cxTranslate }}\n            </button>\n\n            <ng-container\n              *ngIf=\"\n                layoutOption === savedCartFormType.DELETE;\n                else isRestoreSavedCart\n              \"\n            >\n              <button\n                *ngIf=\"cart.code\"\n                (click)=\"deleteCart(cart.code)\"\n                [disabled]=\"isDisableDeleteButton$ | async\"\n                class=\"ml-2 btn btn-primary\"\n                type=\"button\"\n              >\n                {{ 'savedCartDialog.delete' | cxTranslate }}\n              </button>\n            </ng-container>\n\n            <ng-template #isRestoreSavedCart>\n              <button\n                *ngIf=\"cart.code\"\n                (click)=\"restoreSavedCart(cart.code)\"\n                [disabled]=\"isDisableRestoreButton$ | async\"\n                class=\"ml-2 btn btn-primary\"\n                type=\"button\"\n              >\n                {{ 'savedCartDialog.restore' | cxTranslate }}\n              </button>\n            </ng-template>\n          </div>\n        </ng-container>\n        <!-- end DELETE form -->\n\n        <!-- start SAVE and EDIT form -->\n        <ng-template #saveAndEditCart>\n          <ng-container *ngIf=\"layoutOption === savedCartFormType.SAVE\">\n            <p class=\"cx-saved-cart-form-subtitle\">\n              {{ 'savedCartDialog.itemsSavedForLater' | cxTranslate }}\n            </p>\n            <p *cxFeature=\"'a11yRequiredAsterisks'\" class=\"form-legend\">\n              {{ 'formLegend.required' | cxTranslate }}\n            </p>\n          </ng-container>\n\n          <div class=\"cx-saved-cart-form-row\">\n            <ng-container>\n              <label>\n                <span class=\"cx-saved-carts-label label-content\"\n                  >{{ 'savedCartDialog.savedCartName' | cxTranslate }}\n                  <abbr\n                    *cxFeature=\"'a11yRequiredAsterisks'\"\n                    aria-hidden=\"true\"\n                    class=\"text-decoration-none required-asterisk\"\n                    title=\"{{ 'common.required' | cxTranslate }}\"\n                    >*</abbr\n                  ></span\n                >\n                <input\n                  required=\"true\"\n                  [maxLength]=\"nameMaxLength\"\n                  class=\"form-control\"\n                  [attr.aria-describedby]=\"'nameError'\"\n                  formControlName=\"name\"\n                  required\n                  type=\"text\"\n                />\n\n                <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n                <cx-form-errors\n                  *cxFeature=\"'formErrorsDescriptiveMessages'\"\n                  id=\"nameError\"\n                  aria-live=\"off\"\n                  [translationParams]=\"{\n                    label: 'savedCartDialog.savedCartName' | cxTranslate,\n                  }\"\n                  [control]=\"form.get('name')\"\n                ></cx-form-errors>\n\n                <cx-form-errors\n                  *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n                  [control]=\"form.get('name')\"\n                ></cx-form-errors>\n              </label>\n            </ng-container>\n          </div>\n\n          <div class=\"cx-saved-cart-form-row\">\n            <label>\n              <span class=\"cx-saved-carts-label label-content\"\n                >{{ 'savedCartDialog.savedCartDescription' | cxTranslate }}\n                <span class=\"cx-saved-carts-label-optional\">\n                  ({{ 'savedCartDialog.optional' | cxTranslate }})\n                </span></span\n              >\n              <textarea\n                [maxLength]=\"descriptionMaxLength\"\n                class=\"form-control\"\n                [attr.aria-describedby]=\"'descriptionError'\"\n                formControlName=\"description\"\n                rows=\"5\"\n              ></textarea>\n\n              <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n              <cx-form-errors\n                *cxFeature=\"'formErrorsDescriptiveMessages'\"\n                id=\"descriptionError\"\n                aria-live=\"off\"\n                [translationParams]=\"{\n                  label: 'savedCartDialog.savedCartDescription' | cxTranslate,\n                }\"\n                [control]=\"form.get('description')\"\n              ></cx-form-errors>\n\n              <cx-form-errors\n                *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n                [control]=\"form.get('description')\"\n              ></cx-form-errors>\n\n              <p class=\"cx-saved-carts-input-hint\">\n                {{\n                  'savedCartDialog.charactersLeft'\n                    | cxTranslate: { count: descriptionsCharacterLeft }\n                }}\n              </p>\n            </label>\n          </div>\n          <div class=\"cx-saved-cart-form-footer\">\n            <button\n              (click)=\"close('Close Save Cart Dialog')\"\n              [disabled]=\"isLoading$ | async\"\n              class=\"btn btn-secondary\"\n              type=\"button\"\n            >\n              {{ 'savedCartDialog.cancel' | cxTranslate }}\n            </button>\n            <button\n              (click)=\"saveOrEditCart(cart?.code)\"\n              [disabled]=\"isLoading$ | async\"\n              class=\"btn btn-primary\"\n              type=\"button\"\n            >\n              {{ 'savedCartDialog.save' | cxTranslate }}\n            </button>\n          </div>\n        </ng-template>\n        <!-- end SAVE and EDIT form -->\n      </div>\n    </form>\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: i3$2.LaunchDialogService
  }, {
    type: i0.ElementRef
  }, {
    type: i2.SavedCartFacade
  }, {
    type: i3$1.EventService
  }, {
    type: i3$1.RoutingService
  }, {
    type: i3$1.GlobalMessageService
  }], {
    handleClick: [{
      type: HostListener,
      args: ['click', ['$event']]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultSavedCartFormLayoutConfig = {
  launch: {
    SAVED_CART: {
      inline: true,
      component: SavedCartFormDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SavedCartFormDialogModule {
  static {
    this.ɵfac = function SavedCartFormDialogModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SavedCartFormDialogModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SavedCartFormDialogModule,
      declarations: [SavedCartFormDialogComponent],
      imports: [CommonModule, FormsModule, ReactiveFormsModule, FormErrorsModule, I18nModule, IconModule, KeyboardFocusModule, FeaturesConfigModule],
      exports: [SavedCartFormDialogComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule, ReactiveFormsModule, FormErrorsModule, I18nModule, IconModule, KeyboardFocusModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SavedCartFormDialogModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule, ReactiveFormsModule, FormErrorsModule, I18nModule, IconModule, KeyboardFocusModule, FeaturesConfigModule],
      declarations: [SavedCartFormDialogComponent],
      exports: [SavedCartFormDialogComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SavedCartComponentsModule {
  static {
    this.ɵfac = function SavedCartComponentsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SavedCartComponentsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SavedCartComponentsModule,
      imports: [RouterModule, AddToSavedCartModule, SavedCartFormDialogModule, SavedCartListModule, SavedCartDetailsModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: SavedCartOrderEntriesContextToken,
        useExisting: SavedCartOrderEntriesContext
      }, {
        provide: NewSavedCartOrderEntriesContextToken,
        useExisting: NewSavedCartOrderEntriesContext
      }, provideDefaultConfig(defaultSavedCartFormLayoutConfig)],
      imports: [RouterModule, AddToSavedCartModule, SavedCartFormDialogModule, SavedCartListModule, SavedCartDetailsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SavedCartComponentsModule, [{
    type: NgModule,
    args: [{
      imports: [RouterModule, AddToSavedCartModule, SavedCartFormDialogModule, SavedCartListModule, SavedCartDetailsModule],
      providers: [{
        provide: SavedCartOrderEntriesContextToken,
        useExisting: SavedCartOrderEntriesContext
      }, {
        provide: NewSavedCartOrderEntriesContextToken,
        useExisting: NewSavedCartOrderEntriesContext
      }, provideDefaultConfig(defaultSavedCartFormLayoutConfig)]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddToSavedCartComponent, AddToSavedCartModule, NewSavedCartOrderEntriesContext, SavedCartComponentsModule, SavedCartDetailsActionComponent, SavedCartDetailsItemsComponent, SavedCartDetailsModule, SavedCartDetailsOverviewComponent, SavedCartDetailsService, SavedCartFormDialogComponent, SavedCartFormDialogModule, SavedCartListComponent, SavedCartListModule, SavedCartOrderEntriesContext, defaultSavedCartFormLayoutConfig };
